import {pollsListSlice, PollsListState} from './list';
import {combineReducers} from 'redux';
import {pollDetailsSlice, PollsDetailsState} from './details';

export interface PollsState {
  list: PollsListState;
  details: PollsDetailsState;
}

export const polls = combineReducers({
  list: pollsListSlice.reducer,
  details: pollDetailsSlice.reducer,
});
